import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import apiService from '../services/api';

interface NotificationSettings {
  notifications_enabled: boolean;
  notification_time: string;
}

export const useNotificationSettings = () => {
  const { trainer } = useAuth();
  const [settings, setSettings] = useState<NotificationSettings | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  const fetchSettings = async () => {
    if (!trainer) return;

    try {
      setIsLoading(true);
      const response = await apiService.getNotificationSettings();
      setSettings(response);
    } catch (error) {
      console.error('Error fetching notification settings:', error);
      // Устанавливаем настройки по умолчанию
      setSettings({
        notifications_enabled: false,
        notification_time: '19:00'
      });
    } finally {
      setIsLoading(false);
    }
  };

  const saveSettings = async (newSettings: NotificationSettings) => {
    if (!trainer) return;

    try {
      setIsSaving(true);
      
      const response = await apiService.saveNotificationSettings(newSettings);
      setSettings(newSettings);
      return response;
    } catch (error) {
      console.error('Error saving notification settings:', error);
      throw error;
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, [trainer]);

  return {
    settings,
    isLoading,
    isSaving,
    saveSettings,
    refetch: fetchSettings,
  };
}; 